import { render, staticRenderFns } from "./SlideGameRecapMobile.vue?vue&type=template&id=72021744&scoped=true&"
import script from "./SlideGameRecapMobile.vue?vue&type=script&lang=js&"
export * from "./SlideGameRecapMobile.vue?vue&type=script&lang=js&"
import style0 from "./SlideGameRecapMobile.vue?vue&type=style&index=0&id=72021744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72021744",
  null
  
)

export default component.exports